import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Screen from "models/screen";

export interface PermissionsSliceState {
    screens: Screen[]
}

export const initialState: PermissionsSliceState = {
    screens: [],
};

const permissionsSlice = createSlice({
    name: "permissions",
    initialState,
    reducers: {
        setScreens(state: PermissionsSliceState, { payload }: PayloadAction<Screen[]>) {
            state.screens = payload
        },
    }
});
export const {
    setScreens,
} = permissionsSlice.actions;
export default permissionsSlice.reducer;